/**
 * PresenceAvatars.tsx
 * Compact avatar group of who else is viewing the schedule (UX overhaul, M8).
 */

import React from 'react';
import { AvatarGroup, Avatar, Tooltip, Box } from '@mui/material';
import type { PresenceViewer } from '../../services/scheduleEmployeeBars';

function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export const PresenceAvatars: React.FC<{ viewers: PresenceViewer[] }> = ({ viewers }) => {
  if (!viewers.length) return null;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <AvatarGroup max={5} sx={{ '& .MuiAvatar-root': { width: 26, height: 26, fontSize: '0.64rem', border: '2px solid #fff' } }}>
        {viewers.map((v) => (
          <Tooltip key={v.userKey} title={`${v.displayName} · viewing now`} arrow>
            <Avatar sx={{ bgcolor: 'success.main' }}>{initials(v.displayName)}</Avatar>
          </Tooltip>
        ))}
      </AvatarGroup>
    </Box>
  );
};
